import React, { useEffect, useState, useRef } from "react";
//import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { injectModels } from "../redux/injectModels";
//import { routes } from "../constants/routes";
import { useDispatch } from "react-redux";
import * as CONSTANTS from "../redux/Models/Application/constants";
import HeaderLogo from "../components/Logo/HeaderLogo";
import ReCAPTCHA from "react-google-recaptcha";
import { VerifyCaptcha } from "../services/InquiryService";
import { GlobalSettingService } from "../services";
import { globalConstant } from "../constants/globalConstant";
import { handleConsoleError } from "../utils/common-methods";


function Login(props) {
  const recaptchaRef = useRef(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  //const [error, setError] = useState("");
  const [passError, setPassError] = useState("");
  const [emailError, setEmailError] = useState("");

  //const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [token, setToken] = useState(null);
  const [captchaError, setCaptchaError] = useState("");
  const [captchaKey, setCaptchaKey] = useState("");

  //const navigate = useNavigate();
  const dispatch = useDispatch();

  const getCaptchaDetails = async () => {
    try {
      const res = await GlobalSettingService.getRecaptchaDetails();
      if (res?.isSuccess && res?.data) {
        setCaptchaKey(GlobalSettingService.decrypt(res?.data?.keyValue));
      }
    } catch (error) {
      const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  useEffect(() => {
    getCaptchaDetails();

    let email = localStorage.getItem("RememberMeEmail");
    let password = localStorage.getItem("Password");
    //const id = localStorage.getItem("access_token"); //localStorage.getItem("UserId");
    if (email != null && password != null) {
      setEmail(email);
      setPassword(password);
      //setRememberMe(true);
    }
  }, []);

  const handleEmailChange = (e) => {
    e.preventDefault();
    const val = e.target.value.trim();
    if (val === "") {
      setEmailError("Email is required");
    } else if (!globalConstant.emailRegex.test(val)) {
      setEmailError("Please enter a valid email");
    } else {
      setEmailError("");
    }

    setEmail(val);
  };

  const handlePasswordChange = (e) => {
    // e.preventDefault();
    const val = e.target?.value;
    if (val.trim() === "") {
      setPassError("Password is required");
    } else {
      setPassError("");
    }
    setPassword(val);
  };
  const togglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  // const handleSignup = (e) => {
  //   navigate(routes.SIGNUP);
  // };

  // const handleRememberMeChange = (e) => {
  //   setRememberMe(e.target.checked);
  // };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      // if (process.env.NODE_ENV === "production") {
      if (!token) {
        setCaptchaError("Captcha is required.");
        return;
      }
   
      setCaptchaError("");
      props.application.setLoading(true);

      await VerifyCaptcha({
        captchaToken: token,
      });
 //}
      props.application.setLoading(true, "Login!");

      let valid = true;

      if (password === "") {
        setPassError("Password is required");
        valid = false;
      } else {
        setPassError("");
      }

      if (email?.trim() === "") {
        setEmailError("Email is required");
        valid = false;
      } else if (!globalConstant.emailRegex.test(email)) {
        setEmailError("Please enter a valid email");
        valid = false;
      } else {
        setEmailError("");
      }

      if (!valid) {
        props.application.setLoading(false, "");
        return;
      } else {
        const data = {
          username: email?.trim(),
          password: password,
        };

        props.application.setLoading(true);
        const res = await props.auth.userLogin2FA(data);
        if (res?.isSuccess) {
          props.application.setLoading(false);
          toast.success(
            "Two verification code sent to your registered email address.",
          );
          toggleCodeVerification(res?.data?.userID);
        } else {
          props.application.setLoading(false);
          localStorage.clear();
          toast.error(res?.message ||res?.Errors?.[0]?.Message||"Something went wrong");
           recaptchaRef.current?.reset();
    setToken(null);
          return;
        }
      }
    } catch (err) {
      props.application.setLoading(false);
      //setError(err.message);
      toast.error(err?.message || "Something went wrong.");
       recaptchaRef.current?.reset();
    setToken(null);
    }
  };

  const toggleForget = () => {
    dispatch({
      type: CONSTANTS.SET_CURRENT_MODAL,
      payload: CONSTANTS.FORGET_MODAL,
    });
  };
  const toggleSignup = () => {
    dispatch({
      type: CONSTANTS.SET_CURRENT_MODAL,
      payload: CONSTANTS.SIGNUP_MODAL,
    });
  };

  const toggleCodeVerification = (userId) => {
    dispatch({
      type: CONSTANTS.SET_CURRENT_MODAL,
      payload: CONSTANTS.CLEAR_MODAL,
    });

    dispatch({
      type: CONSTANTS.VERIFY_MODAL_TOGGLE,
      payload: { value: true, userId },
    });
  };

  return (
    <React.Fragment>
      <section className="loginswallow">
        <div className="form-container" id="form-container">
          <form id="login-form" onSubmit={handleSubmit}>
            <HeaderLogo></HeaderLogo>
            <h3>Login</h3>
            <label>Email</label>
            <input
              type="email"
              id="inputEmail"
              className="form-control"
              placeholder="Email"
              value={email}
              autoFocus=""
              onChange={handleEmailChange}
            />
            {emailError && <p className="text-danger">{emailError}</p>}

            <label>Password</label>
            <div className="password-container">
              <input
                type={showPassword ? "text" : "password"}
                id="inputPassword"
                className="form-control"
                placeholder="Password"
                value={password}
                onChange={handlePasswordChange}
              />
              {showPassword ? (
                <i
                  className="fa-solid fa-eye"
                  id="login-eye"
                  onClick={togglePassword}
                ></i>
              ) : (
                <i
                  className="fa-solid fa-eye-slash"
                  id="login-eye"
                  onClick={togglePassword}
                ></i>
              )}
            </div>
            {passError && <p className="text-danger">{passError}</p>}
            
            <div className="password-container">
              {captchaKey && (
                <ReCAPTCHA
                 ref={recaptchaRef}
                  sitekey={captchaKey}
                  onChange={(value) => setToken(value)}
                />
              )}
            </div>
            {captchaError && (
              <span style={{ color: "red" }}>{captchaError}</span>
            )}
            <button type="submit">Log In</button>
            <p className="signup-text">
              Problem in Sign-in?{" "}
              <a href="#!" onClick={() => toggleForget()}>
                Forgot Password
              </a>
            </p>
            <p className="signup-text">
              Don't have an account?{" "}
              <a href="#!" onClick={() => toggleSignup()}>
                Sign Up
              </a>
            </p>
          </form>
        </div>
      </section>
    </React.Fragment>
  );
}
export default injectModels(["application", "auth"])(Login);
